import { v4 as uuidv4 } from 'uuid';

export class PurchaseStore {
  uuid: string = uuidv4();

  name?: string;

  isMCC? : boolean; // MCC店舗

  constructor(init?: Partial<PurchaseStore>) {
    Object.assign(this, init);

    if (!this.uuid) {
      this.uuid = uuidv4();
    }
  }
}
